import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  faUser,
  faHandPointLeft,
  faHandPointRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import FileDownload from 'js-file-download';
import Notes from './Form/Notes';
import { Input, Radio, Select, AutoComplete } from 'antd';
import INSTALLERS_QUERIES from '../graphql/installers/queries';
import AUTH_QUERIES from '../graphql/auth/queries';
import AUTH_MUTATIONS from '../graphql/auth/mutations';
import { axiosInstance, get_file_name } from '../shared/utils/axios';
import BaconButton from '../shared/components/Button';
import InstallModal from '../shared/components/InstallModal';
import GreaseModal from '../shared/components/GreaseModal';
import { colors } from '../config/constants';
import { useUserContext } from '../shared/hooks';

const { Option } = Select;

const ScreenContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: nowrap;
  min-height: 100vh;
`;

const FormContainer = styled.div`
  flex-grow: 4;
  display: flex;
  flex-direction: column;
  padding-left: 3vw;
  margin: 50px 0px;
`;
const InstructionsContent = styled.div`
  white-space: pre-line;
`;

const RadioContainer = styled.div`
  margin-top: 3vh;
`;

const ImportantNoteContainer = styled.div`
  display: flex;
`;

const ClientSelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${colors.COLOR_BACON_SAYS_TEXT};
`;

const FormHeading = styled.h1`
  font-family: LexiaAd;
`;

const FormSubheading = styled.div`
  display: flex;
  width: 80%;
  margin-bottom: 15px;
  text-align: justify;
  text-justify: inter-word;
`;

const ImportantNoteheading = styled.div`
  margin-bottom: 15px;
  text-align: left;
  font-size: 16px;
  text-decoration-line: underline;
`;

const FormSubTitle = styled.div`
  font-family: LexiaAd;
  margin-left: 15px;
`;

const BottomText = styled.div`
  display: flex;
  margin-bottom: 2vh;
  font-size: 12px;
  align-self: stretch;
  color: ${colors.COLOR_GRAY_TEXT};
`;

const FormTextSeparator = styled.div`
  flex-grow: 4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const BelowInputsContainer = styled.div`
  display: flex;
  margin-right: 18.2%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${colors.COLOR_BACON_SAYS_TEXT};
`;

const ServerScreen = () => {
  const userConsumer = useUserContext();
  // Retain the user info from the first user login
  const currentUserOrgId =
    userConsumer.user.organization?.id ||
    JSON.parse(localStorage.getItem('organization.id'));
  if (userConsumer.user.organization?.id) {
    localStorage.setItem(
      'organization.id',
      JSON.stringify(userConsumer.user.organization.id)
    );
  }
  const currentUserOrgName =
    userConsumer.user.organization?.name ||
    JSON.parse(localStorage.getItem('organization.name'));
  if (userConsumer.user.organization?.name) {
    localStorage.setItem(
      'organization.name',
      JSON.stringify(userConsumer.user.organization.name)
    );
  }

  const [organizationUpdated, setOrganizationUpdated] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);

  // Form
  const [organizations, setOrganizations] = useState([]);
  const [orgId, setOrgId] = useState(
    JSON.parse(localStorage.getItem('user.organization'))?.id
  );
  const [name, setName] = useState(
    JSON.parse(localStorage.getItem('user.organization'))?.name
  );
  const [version, setVersion] = useState(
    JSON.parse(localStorage.getItem('user.organization'))?.server_version
  );
  const [fqdn, setFQDN] = useState(
    JSON.parse(localStorage.getItem('user.organization'))?.fqdn
  );
  const [os, setOs] = useState();
  const [type, setType] = useState(
    JSON.parse(localStorage.getItem('user.organization'))?.offline
      ? 'offline'
      : 'web'
  );
  const [serverOsOptions, setServerOsOptions] = useState([]);
  const [versionBE, setVersionBE] = useState([]);
  const [latestVersion, setLatestVersion] = useState('version');
  const [installCmd, setinstallCmd] = useState(
    'sudo dpkg -i bacon_version_fqdn.deb'
  );

  const [isStaffUser, setIsStaffUser] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isLocked, setIsLocked] = useState(true);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [modalStatus, setModalStatus] = useState('loading');

  const openModal = () => {
    setModalStatus('loading');
    setShowModal(true);
    setLoadingModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const webNotes = [
    `Run the deb installer:
    ${installCmd}`,
  ];

  const offlineNotes = [
    `Unzip the install file. Then, run the deb installer:
    ${installCmd}`,
  ];

  const noteMapper = {
    name: {
      text: 'Please select which organization to download as. ',
      // gif: 'organization',
    },
    version: {
      text: 'Please select your desired version of Bacon for installation. ',
      gif: 'version',
    },
    fqdn: {
      text: 'Enter the Bacon Server Domain Name. This is usually a memorable name setup with a DNS redirect to something like: "bacon.mycompany.com"',
      gif: 'fqdn',
    },
    os: {
      text: 'Please select which operating system to install Bacon server on.',
      gif: 'installerOS',
    },
    server: {
      text: 'Please enter the IP of the intended Bacon server machine. You can find this with: ifconfig',
      gif: 'ifconfig',
    },
    offline: {
      text: '',
      gif: 'type',
    },
    web: {
      text: '',
      gif: 'type0',
    },
    default: {
      text: [
        {
          title: 'Bacon Server Installation Instructions:',
        },
        'After running the pre-install script, you are ready to install Bacon.',
        type === 'web' ? (
          <InstructionsContent>{webNotes}</InstructionsContent>
        ) : (
          <InstructionsContent>{offlineNotes}</InstructionsContent>
        ),
      ],
    },
  };

  const [notes, setNotes] = useState(noteMapper.default.text);
  const [gif, setGif] = useState(undefined);
  const [downloadErrorMessage, setDownloadErrorMessage] = useState(null);

  // Queries
  useQuery(INSTALLERS_QUERIES.INSTALLERS_GET_OS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setServerOsOptions(
        data?.getOsResponse?.map((optionBE) => ({
          value: optionBE.id,
          text: optionBE.name,
        }))
      );
    },
  });

  useQuery(INSTALLERS_QUERIES.INSTALLERS_GET_VERSIONS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const allVersions = data?.getVersionsResponse?.map((optionBE) => ({
        value: optionBE.id,
        text: optionBE.friendly_name,
      }));
      setVersionBE(allVersions);
    },
  });

  useEffect(() => {
    var text = 'version';
    for (const item of versionBE) {
      if (item.value == version) {
        text = item.text;
        setLatestVersion(text);
        setinstallCmd('sudo dpkg -i bacon_' + text + '-' + fqdn + '.deb');
      }
    }
  }, [version]);

  const { data: organizationData } = useQuery(AUTH_QUERIES.AUTH_ORGANIZATION, {
    fetchPolicy: 'network-only',
  });

  if (!organizationUpdated && organizationData) {
    const allOrganizations = organizationData.getOrganizationResponse;
    setOrganizations(allOrganizations);
    setOrganizationUpdated(true);
    setIsStaffUser(allOrganizations.length > 1);
    setIsHidden(allOrganizations.length > 1);
    let organization = allOrganizations.filter((org) => {
      if (currentUserOrgId === org.id) return org;
    });
    if (organization.length === 0) {
      organization = JSON.parse(localStorage.getItem('user.organization'));
    } else {
      localStorage.setItem(
        'user.organization',
        JSON.stringify(organization[0] || [])
      );
    }
    setOrgId(organization[0]?.id);
    setName(organization[0]?.name);
    setFQDN(organization[0]?.fqdn);
    setVersion(organization[0]?.serverVersion);
    setType(organization[0]?.offline ? 'offline' : 'web');
  }

  const [editOrganizationField] = useMutation(
    AUTH_MUTATIONS.AUTH_UPDATE_ORGANIZATION
  );

  const updateOrganizationField = (field, value) => {
    const organizationId = orgId;

    var bodyObj = new Object();
    bodyObj[field] = value;

    editOrganizationField({
      variables: {
        organizationId,
        body: bodyObj,
      },
    }).then((response) => {
      let organization = response.data.updateOrganization;
      localStorage.setItem(
        'user.organization',
        JSON.stringify(organization || [])
      );
      // setFQDN(organization.fqdn);
      setVersion(organization.serverVersion);
      setType(organization.offline ? 'offline' : 'web');
    });
  };

  const osBE = serverOsOptions;

  useEffect(() => {
    const lastOS = JSON.parse(localStorage.getItem('user.organization'))?.os;
    setOs(
      typeof lastOS === 'string'
        ? osBE?.find((os) => os.text === lastOS)?.value
        : lastOS
    );
  }, [serverOsOptions]);

  const onConfirmHandler = () => {
    setIsHidden(false);
  };

  const onUnlockHandler = () => {
    setIsLocked(false);
  };

  const onDownloadHandler = () => {
    updateOrganizationField('fqdn', fqdn);
    openModal();
    const downloadData = {
      fqdn,
      os_id: os,
      version_id: version,
      offline: type === 'offline',
    };
    if (organizations.length > 1) {
      downloadData.organization_id = orgId;
    }
    axiosInstance({
      method: 'post',
      url: '/installers/download/',
      responseType: 'blob',
      data: downloadData,
    })
      .then(function (response) {
        setLoadingModal(false);
        setModalStatus('complete');
        FileDownload(response.data, get_file_name(response.headers));
      })
      .catch(function () {
        setLoadingModal(false);
        setModalStatus('error');
        setDownloadErrorMessage(
          'There was an error processing the request. Check the server domain name and IP format.'
        );
      });
  };

  const isUndefined = (u) => typeof u === 'undefined';

  const disabled =
    isUndefined(fqdn) ||
    isUndefined(os) ||
    isUndefined(version) ||
    !fqdn ||
    !`${os}` ||
    !`${version}`;

  const onHoverHandler = (e) => {
    setNotes(noteMapper[e].text);
    setGif(noteMapper[e].gif);
  };

  const onUnhoverHandler = () => {
    setNotes(noteMapper.default.text);
    setGif(undefined);
  };

  // useEffect(() => {
  //   setIsReadOnly(currentUserOrgName !== name);
  // }, [name]);

  return (
    <>
      <ScreenContainer>
        <FormContainer>
          <FormTextSeparator>
            <FormContent>
              <FormHeading>Download Install Package</FormHeading>
              {isStaffUser && (
                <>
                  <fieldset
                    style={{
                      border: '2px solid #3c3c3c',
                      margin: '0 0 5px 0',
                      width: '80%',
                      padding: '10px',
                    }}
                  >
                    <legend style={{ width: '200px' }}>
                      <div style={{ display: 'flex' }}>
                        <FontAwesomeIcon
                          icon={faUser}
                          style={{ margin: '2px 0 0 5px' }}
                        />
                        <FormSubTitle>Select Client:</FormSubTitle>
                      </div>
                    </legend>
                    <ImportantNoteContainer>
                      <FontAwesomeIcon
                        icon={faHandPointRight}
                        style={{ margin: '5px 2% 0 0' }}
                      />
                      <ImportantNoteheading>
                        <b>IMPORTANT:</b>&nbsp;The correct organization&nbsp;
                        <i>must</i>&nbsp;be selected or the license will not
                        apply
                      </ImportantNoteheading>
                      <FontAwesomeIcon
                        icon={faHandPointLeft}
                        style={{ margin: '5px 0 0 2%' }}
                      />
                    </ImportantNoteContainer>
                    <FormSubheading>
                      The selected organization will be use to pre-fill the FQDN
                      and license Key
                    </FormSubheading>
                    <ClientSelectionContainer>
                      <AutoComplete
                        value={name}
                        placeholder="Organization"
                        onMouseEnter={() => onHoverHandler('name')}
                        onMouseLeave={onUnhoverHandler}
                        options={organizations.map((org) => ({
                          value: org.name,
                          label: org.name,
                          org,
                        }))}
                        filterOption={(inputValue, option) =>
                          option.value
                            .toUpperCase()
                            .includes(inputValue.toUpperCase())
                        }
                        onSelect={(value, option) => {
                          const organization = option.org;
                          setOrgId(organization.id);
                          setName(organization.name);
                          setFQDN(organization.fqdn);
                          setIsHidden(true);
                        }}
                        onChange={(value) => setName(value ?? '')}
                      />

                      <BaconButton
                        className="confirmButton"
                        disabled={!isHidden}
                        text="Confirm"
                        onClick={onConfirmHandler}
                      ></BaconButton>
                    </ClientSelectionContainer>
                  </fieldset>
                  <hr
                    style={{
                      border: '1px solid #3c3c3c',
                      margin: '0 0 5px 0',
                      width: '80%',
                    }}
                  />
                </>
              )}
              {!isHidden && (
                <>
                  <FormSubheading>
                    Please Prepare to download the Bacon Server application.
                    Please enter your FQDN, Bacon version, and host operating
                    system
                  </FormSubheading>
                  <Select
                    placeholder="Bacon Server version"
                    // allowClear
                    onChange={(e) => {
                      setVersion(e);
                      var text = 'version';
                      for (const item of versionBE) {
                        if (item.value == e) {
                          text = item.text;
                        }
                      }
                      setLatestVersion(text);
                      updateOrganizationField('server_version', e);
                    }}
                    onMouseEnter={() => onHoverHandler('version')}
                    onMouseLeave={onUnhoverHandler}
                    value={version}
                    id="VersionSelector"
                  >
                    {versionBE.map((os) => (
                      <Option key={os.value} value={os.value}>
                        {os.text}
                      </Option>
                    ))}
                  </Select>
                  <ClientSelectionContainer>
                    <Input
                      placeholder="Bacon Server Domain Name"
                      value={fqdn}
                      onChange={(e) => {
                        setFQDN(e.target.value);
                      }}
                      onMouseEnter={() => onHoverHandler('fqdn')}
                      onMouseLeave={onUnhoverHandler}
                      disabled={isLocked}
                    />
                    <BaconButton
                      className="unlockButton"
                      disabled={!isLocked}
                      text="Unlock"
                      onClick={onUnlockHandler}
                    ></BaconButton>
                  </ClientSelectionContainer>
                  <Select
                    placeholder="Operating system"
                    // allowClear
                    showArrow
                    mode={null}
                    value={os}
                    onChange={(e) => setOs(e)}
                    onMouseEnter={() => onHoverHandler('os')}
                    onMouseLeave={onUnhoverHandler}
                    className="notransition"
                    disabled
                  >
                    {osBE.map((os) => (
                      <Option key={os.value} value={os.value}>
                        {os.text}
                      </Option>
                    ))}
                  </Select>

                  <BelowInputsContainer>
                    <RadioContainer>
                      <Radio.Group
                        defaultValue="web"
                        onChange={(e) => {
                          setType(e.target.value);
                          updateOrganizationField(
                            'offline',
                            e.target.value == 'offline'
                          );
                        }}
                        value={type}
                      >
                        <Radio
                          value="web"
                          onMouseEnter={() => onHoverHandler('web')}
                          onMouseLeave={onUnhoverHandler}
                        >
                          Web installer
                        </Radio>
                        <Radio
                          value="offline"
                          onMouseEnter={() => onHoverHandler('offline')}
                          onMouseLeave={onUnhoverHandler}
                        >
                          Offline installer
                        </Radio>
                      </Radio.Group>
                    </RadioContainer>
                    <BaconButton
                      disabled={disabled}
                      text="Download"
                      onClick={onDownloadHandler}
                    ></BaconButton>
                  </BelowInputsContainer>
                </>
              )}
            </FormContent>
            <BottomText>
              Don’t forget to verify all of the information above for a
              successful installation!
            </BottomText>
          </FormTextSeparator>
        </FormContainer>

        <Notes gif={gif} notes={notes} warning />
      </ScreenContainer>
      <GreaseModal
        maskClosable={false}
        width={1000}
        title=""
        visible={showModal}
        loading={loadingModal}
        onOk={closeModal}
        closable={false}
        keyboard={false}
        showCancelButton={false}
      >
        <InstallModal
          longBuild={type === 'offline'}
          type="server"
          status={modalStatus}
          errorMessage={downloadErrorMessage}
        />
      </GreaseModal>
    </>
  );
};

export default ServerScreen;
